import http, { url } from '../../http'

const API_URL = "labor_recomendations"

class RestriccionesColaboracionesAPI {

  async save(resource) {
    const response = await http(`${API_URL}/save`, 'POST', resource)
    return response
  }

  async getAllPage(id, page) {
    const response = await http(`${API_URL}?page=${page}`)
    return response
  } 

/*   async getAll(id, page) {
    const response = await http(`${API_URL}/companies/${id}?page=${page}`)
    return response
  }  */ 
 
  async get(id, page) {
    const response = await http(`${API_URL}/show/${id}?page=${page}`)
    return response
  }

  async getSpecific(id) {
    const response = await http(`${API_URL}/show_specific_followup/${id}`)
    return response
  }

  async getOrder(id) {
    const response = await http(`${API_URL}/${id}`)
    return response
  }

  async getPagination(id, page) {
    const response = await http(`${API_URL}/show/${id}?page=${page}`)
    return response
  }

  async getOrderByID(id) {
    const response = await http(`ocupational_medical/companies/danger/${id}`, 'POST')
    return response
  }

  async getAllRestriccionesPage(companiesID, page, search) {
    const response = await http(`ocupational_medical/companies/danger/${companiesID}?page=${page}&search=${search}`, 'POST')
    return response || null
  }

/*   async getAllRestriccionesPage(id,page) {
    const response = await http(`ocupational_medical/companies/danger/${id}?page=${page}`)
    return response
  } */

  async getEmployee(id) {
    const response = await http(`${API_URL}/showEmployees/${id}`)
    return response
  }

  async update(id, resource) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', resource)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  } 
  
}

export default new RestriccionesColaboracionesAPI()